'use strict';

import ua from './view/_ua';
import height from './view/_height';
import header from './view/_header';
import scroll from './view/_scroll';
import detailSlider from './view/_detailSlider';
import more from './view/_more';
